import { useDebugModeStore } from '../state/debugModeStore';

import { LevelPathItem, useCanvasStore } from '~/scenes/Build/scenes/FlowBuilder/stores';

// Hooks for React components or hooks
export const useCurrentLevelName = (): string => {
  const isDebugMode = useDebugModeStore(state => state.isDebugMode);
  const debugName = useDebugModeStore(state => state.debuggerCurrentLevelName);
  const wipName = useCanvasStore(state => state.currentLevelName);
  return isDebugMode ? debugName : wipName;
};

export const useCurrentLevelPath = (): LevelPathItem[] => {
  const isDebugMode = useDebugModeStore(state => state.isDebugMode);
  const debugPath = useDebugModeStore(state => state.debuggerCurrentLevelPath);
  const wipPath = useCanvasStore(state => state.currentLevelPath);
  return isDebugMode ? debugPath : wipPath;
};

// Getters for synchronous code outside of React components or hooks
export const getCurrentLevelName = (): string => {
  const { isDebugMode, debuggerCurrentLevelName } =
    useDebugModeStore.getState();
  const { currentLevelName } = useCanvasStore.getState();
  return isDebugMode ? debuggerCurrentLevelName : currentLevelName;
};

export const getCurrentLevelPath = (): LevelPathItem[] => {
  const { isDebugMode, debuggerCurrentLevelPath } =
    useDebugModeStore.getState();
  const { currentLevelPath } = useCanvasStore.getState();
  return isDebugMode ? debuggerCurrentLevelPath : currentLevelPath;
};
